@if (type() === 'default') {
  <div class="w-full h-full flex flex-col gap-6 items-center justify-center relative">
    <div class="max-w-[50px]">
      <img
        class="animate-pulse"
        src="icons/icon-512x512.png" />
    </div>
    <div class="w-[200px] h-[2px] bg-[#333] relative overflow-hidden rounded-sm">
      <div class="animate-widthProgress w-0 h-full bg-neon rounded-sm shadow-[0_0_10px_2px_#e0ff00]"></div>
    </div>
  </div>
} @else if (type() === 'spinner') {
  <div
    class="h-full relative flex items-center justify-center"
    [ngClass]="{
      'scale-50': size() === 'small',
      'scale-100': size() === 'medium',
      'scale-150': size() === 'large',
    }">
    <div class="w-8 h-8 border-2 border-white/10 border-t-neon rounded-full animate-spin"></div>
  </div>
}
